import axios from 'axios';
import Qs from 'qs';

export function Get (url, params) {
  // console.log(url);
  // console.log(params);
  return respond_function(axios.get(url, { params }));
}

export function Post (url, params) {
  return respond_function(axios.post(url, Qs.stringify(params), { headers: { 'Content-Type':'application/x-www-form-urlencoded' }}));
};

let respond_function = (request_promise) =>{
    return request_promise.then((res) => {
      const selfDefinedRes = res.data;
      console.error(selfDefinedRes);
      
      if (selfDefinedRes.code == 1001){
        return Promise.resolve(selfDefinedRes.data);
      } else if (selfDefinedRes.code == 28126){
        return Promise.reject(selfDefinedRes);
      } else {
        return Promise.reject(selfDefinedRes);
      }
  });
}


// WEBPACK FOOTER //
// ./src/utils/http.js